import { FEE_BASE_LABEL, Vehicle } from '../types/vehicle';

/**
 * 재원 기본정보 — 규약에서 읽는 값을 화면 말로. 자금원(investment_vehicles)에 들어 있다.
 * 보수율이 비어 있으면 「규약 확인 전」으로 본다.
 */
export interface FundInfo {
  paymentMethod: string;
  vehicleType: string | null;
  fiscalYearEnd: string | null;
  auditor: string | null;
  hurdle: number;
  mgmtFeeRate: number;
  mgmtFeeBase: string;
  /** 관리보수를 한 줄로 — 「약정총액(투자기간 뒤 투자잔액)의 연 2.0% · 선취 3년」 */
  mgmtFeeText: string;
  carryRate: number;
  lossOrder: string | null;
}

export function fundInfo(v: Vehicle | undefined): FundInfo | undefined {
  if (!v || v.mgmtFeeRate == null) return undefined;
  return {
    paymentMethod: v.paymentMethod === 'installment' ? '분할납' : v.paymentMethod === 'lump_sum' ? '일시납' : '확인 전',
    vehicleType: v.vehicleType ?? null,
    fiscalYearEnd: v.fiscalYearEnd ?? null,
    auditor: v.auditor ?? null,
    hurdle: v.hurdleRate ?? 0,
    mgmtFeeRate: v.mgmtFeeRate,
    mgmtFeeBase: FEE_BASE_LABEL[v.mgmtFeeBase ?? 'committed'],
    mgmtFeeText: feeText(v),
    carryRate: v.carryRate ?? 0,
    lossOrder: v.lossOrder ?? null,
  };
}

/** 관리보수 한 줄 — 기준이 투자기간 뒤 바뀌거나 선취가 있으면 함께 적는다 */
export function feeText(v: Vehicle): string {
  if (v.mgmtFeeRate == null) return '규약 확인 전';
  const base = FEE_BASE_LABEL[v.mgmtFeeBase ?? 'committed'];
  const after = v.mgmtFeeBaseAfter && v.mgmtFeeBaseAfter !== (v.mgmtFeeBase ?? 'committed') ? `(투자기간 뒤 ${FEE_BASE_LABEL[v.mgmtFeeBaseAfter]})` : '';
  const pre = v.mgmtFeePrepaidYears ? ` · 선취 ${v.mgmtFeePrepaidYears}년` : '';
  return `${base}${after}의 연 ${(v.mgmtFeeRate * 100).toFixed(1)}%${pre}`;
}
